import React from 'react';
export function AboutSection() {
  return <section id="onas" className="w-full bg-white py-16 border-t border-gray-200" data-id="element-8">
      <div className="max-w-6xl mx-auto px-6" data-id="element-9">
        <div className="grid grid-cols-1 md:grid-cols-[220px_1fr] gap-16" data-id="element-10">
          {/* Left Column - Heading */}
          <div data-id="element-11">
            <h2 className="text-2xl font-normal text-[#707070] tracking-wide" data-id="element-12">
              O NÁS
            </h2>
          </div>

          {/* Right Column - Content */}
          <div className="space-y-6 text-[#707070] leading-relaxed" data-id="element-13">
            <p data-id="element-14">
              Jsme systémový integrátor moderních technologií v oboru audio
              video, komunikace a řízení, na trhu od roku 2011. Věnujeme se
              velkým i malým komerčním projektům a exklusivním rezidentním
              stavbám. Na první místa klademe profesionalitu, spolehlivost a
              osobní a férový přístup. Pracujeme s těmi nejlepšími produkty na
              trhu. Máme vlastní SW tým pro AV a řídící systémy. Sázíme na
              dlouhodobou spolupráci a partnerství s našimi dodavateli i
              klienty. Působíme převážně v ČR, ale máme realizace i dalších
              zemích Evropy a USA.
            </p>
            <p data-id="element-15">
              Jako jediná firma v ČR jsme CRESTRON Elite Partner, a i proto
              nabízíme nejlepší řešení a podmínky pro projekty s produkty a
              řešením CRESTRON.
            </p>
          </div>
        </div>
      </div>
    </section>;
}